<template>
  <div class="tx_summary" v-bind:title="title">
    <div v-on:click="toggle_details" style="display: flex; align-items: center; justify-content: space-between">
      <img v-bind:src="type_glyph" class="type_glyph"/>

      <!-- TODO format all tx types (payments, offers, trust sets are done) -->
      <PaymentTx            v-bind:tx="tx"      v-if="tx_type == 'Payment'"              />
      <OfferCreateTx        v-bind:tx="tx" v-else-if="tx_type == 'OfferCreate'"          />
      <OfferCancelTx        v-bind:tx="tx" v-else-if="tx_type == 'OfferCancel'"          />
      <EscrowCreateTx       v-bind:tx="tx" v-else-if="tx_type == 'EscrowCreate'"         />
      <EscrowCancelTx       v-bind:tx="tx" v-else-if="tx_type == 'EscrowCancel'"         />
      <EscrowFinishTx       v-bind:tx="tx" v-else-if="tx_type == 'EscrowFinish'"         />
      <TrustSetTx           v-bind:tx="tx" v-else-if="tx_type == 'TrustSet'"             />
      <SignerListSetTx      v-bind:tx="tx" v-else-if="tx_type == 'SignerListSet'"        />
      <AccountSetTx         v-bind:tx="tx" v-else-if="tx_type == 'AccountSet'"           />
      <AccountDeleteTx      v-bind:tx="tx" v-else-if="tx_type == 'AccountDelete'"        />
      <PaymentChannelClaim  v-bind:tx="tx" v-else-if="tx_type == 'PaymentChannelClaim'"  />
      <PaymentChannelCreate v-bind:tx="tx" v-else-if="tx_type == 'PaymentChannelCreate'" />
      <PaymentChannelFund   v-bind:tx="tx" v-else-if="tx_type == 'PaymentChannelFund'"   />

      <span class="result_glyph">
        <img v-bind:src="result_glyph" width=15 height=15/>
      </span>
    </div>

    <div v-if="!hidden" class="tx_details">
      <RenderedTx v-bind:tx="tx" />
    </div>
  </div>
</template>

<script>
import PaymentTx            from './tx_types/Payment.vue'
import OfferCreateTx        from './tx_types/OfferCreate.vue'
import OfferCancelTx        from './tx_types/OfferCancel.vue'
import EscrowCreateTx       from './tx_types/EscrowCreate.vue'
import EscrowCancelTx       from './tx_types/EscrowCancel.vue'
import EscrowFinishTx       from './tx_types/EscrowFinish.vue'
import TrustSetTx           from './tx_types/TrustSet.vue'
import SignerListSetTx      from './tx_types/SignerListSet.vue'
import AccountSetTx         from './tx_types/AccountSet.vue'
import AccountDeleteTx      from './tx_types/AccountDelete.vue'
import PaymentChannelClaim  from './tx_types/PaymentChannelClaim.vue'
import PaymentChannelCreate from './tx_types/PaymentChannelCreate.vue'
import PaymentChannelFund   from './tx_types/PaymentChannelFund.vue'

import RenderedTx from './RenderedTx.vue'
import util from '../util'

var HasTx = require('../mixins/has_tx')

export default {
  name: 'TxSummary',

  mixins : [HasTx],

  components : {
    PaymentTx,
    OfferCreateTx,
    OfferCancelTx,
    EscrowCreateTx,
    EscrowCancelTx,
    EscrowFinishTx,
    TrustSetTx,
    SignerListSetTx,
    AccountSetTx,
    AccountDeleteTx,
    PaymentChannelClaim,
    PaymentChannelCreate,
    PaymentChannelFund,

    RenderedTx
  },

  data : function(){
    return { hidden : true }
  },


  computed : {
    tx_type : function(){
      return this.tx_obj["TransactionType"];
    },

    result : function(){
      return this.tx_meta["TransactionResult"];
    },

    success : function(){
      return this.result == "tesSUCCESS" ;
    },

    ///

    unix_date : function(){
      return util.ledger_time_to_unix(this.tx_obj["date"]);
    },

    formatted_date : function(){
      return this.$options.filters.moment(this.unix_date, "YYYY-MM-DD HH:mm:ss");
    },

    type_glyph : function(){
      return require("../assets/txs/" + this.tx_type + ".svg");
    },

    title : function(){
      return this.tx_type + " @ " + this.formatted_date;
    },

    result_glyph : function(){
      return this.success ? require("../assets/green-check.svg") :
                            require("../assets/red-x.svg");
    }
  },

  methods : {
    toggle_details : function(){
      this.hidden = !this.hidden;
    }
  }
}
</script>

<style scoped>
.tx_summary{
  cursor: pointer;
}

.type_glyph{
  vertical-align: middle;
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.result_glyph{
  display: inline-block;
  width: 15px;
  float: right;
  margin-right: 5px;
}

.success {
  color: green;
}

.failed {
  color: red;
}

.tx_details {
  border-top: 1px solid black;
  margin-top: 5px;
  padding: 5px;
}
</style>
